// eslint-disable-next-line no-warning-comments
// TODO: replace with material
import React from "react";
import { noop, omit } from "lodash";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import type { CheckboxProps } from "@mui/material/Checkbox";
import type { SxProps, Theme } from "@mui/material/styles";

type Props = {
  name: string;
  label: string;
  onChangeAction: (props: Props, e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  sx?: SxProps<Theme>;
  labelSx?: SxProps<Theme>;
}

const styles = {
  input: {
    position: "absolute",
    top: 2,
    left: 0,
    fontSize: 20,
  },
  label: {
    width: "100%",
    cursor: "pointer",
  },
};

// Basic Input component that provides support for a
// label, onChange/onBlur actions, and uses a generic formData
// map to fill it's own value if present in map
export const CheckboxBasic: React.FC<Props & Partial<CheckboxProps>> = (props) => {
  const { name, label, labelStyle, onChangeAction = noop, sx, labelSx } = props;
  const checkboxProps = omit(props, [
    "formData",
    "inline",
    "onChangeAction",
    "persistTableName",
    "validationSchema",
    "labelStyle",
    "labelSx",
    "sx",
  ]);

  return (
    <Box style={props.style ? { position: "relative", marginLeft: 16, paddingRight: 16, ...props.style } : { position: "relative", marginLeft: 16, paddingRight: 16 }}>
      <FormControlLabel
        sx={sx}
        control={
          <Checkbox
            id={name}
            name={name}
            size={props.size ?? "small"}
            color="secondary"
            {...checkboxProps}
            onChange={(e) =>
              onChangeAction(
                props as unknown as Props,
                e as unknown as React.ChangeEvent<HTMLInputElement>,
              )}
          />
        }
        label={label}
        componentsProps={{ typography: { sx: labelSx, style: { ...styles.label, ...labelStyle } } }}
      />
    </Box>
  );
};
